import GlobalHero from './global-hero';

export default GlobalHero;
